import { HelpIconTooltip } from "@components/common/help-icon-tooltip";
import { InputLabel } from "@mui/material";
import { Box, Stack } from "@mui-wrapper";

interface DatePickerLabelProps {
  /** The text of the label */
  label: string;

  /** Whether the picker below the label is disabled */
  isDisabled?: boolean;

  /** An explanation to offer behind an info icon next to the label */
  infoTooltip?: string;
}

/**
 * The label of a date picker, rendered outside the picker because flat-ui only accepts a plain
 * string as its label and an icon has to sit next to it. InputLabel keeps the theme styling of
 * the labels that flat-ui renders itself.
 */
export function DatePickerLabel({
  label,
  isDisabled,
  infoTooltip,
}: DatePickerLabelProps): React.JSX.Element {
  return (
    <Stack direction="row" sx={{ alignItems: "center", height: "26px" }}>
      <Box component="div">
        <InputLabel disabled={isDisabled}>{label}</InputLabel>
      </Box>

      {infoTooltip && <HelpIconTooltip title={infoTooltip} />}
    </Stack>
  );
}
